import { useContext, useEffect, useState } from 'react'

import {
  Box,
  Button,
  Icon,
  Table,
  TableHeader,
  Text,
} from '@fairfashion/design-system'
import { useNavigate } from 'react-router-dom'

import { FeedbackAlertContext } from '../../../../components/FeedbackAlert'
import { InvoiceIAParserStatusDTO } from '../../../../sdk/invoices/invoice.types'
import { sdk } from '../../../../services/sdk'

export const IAResultTab = () => {
  const [iaResults, setIaResults] = useState<InvoiceIAParserStatusDTO[]>([])
  const [loadingResults, setLoadingResults] = useState(false)
  const navigate = useNavigate()

  const { feedbackAlert } = useContext(FeedbackAlertContext)

  const fetchIAResults = async () => {
    setLoadingResults(true)
    try {
      const results = await sdk.invoices.getInvoiceIAParserResults()
      setIaResults(results)
    } catch (error) {
      feedbackAlert('Erro ao buscar resultados do processamento IA.', 'error')
    } finally {
      setLoadingResults(false)
    }
  }

  useEffect(() => {
    fetchIAResults()
  }, [])

  const resultsTableHeaders: TableHeader[] = [
    {
      key: 'invoiceQuantity',
      label: 'Qtd. de Notas',
      customRender: (data: InvoiceIAParserStatusDTO) => (
        <Text align="center">{data.invoiceQuantity}</Text>
      ),
    },
    {
      key: 'processingStartDate',
      label: 'Data de Envio',
      customRender: (data: InvoiceIAParserStatusDTO) => (
        <Text align="center">
          {data.processingStartDate
            ? new Date(data.processingStartDate).toLocaleString()
            : '-'}
        </Text>
      ),
    },
    {
      key: 'actions',
      label: 'Ações',
      customRender: (data: InvoiceIAParserStatusDTO) => (
        <Button
          variant="outlined"
          onClick={() => {
            navigate(`/iaresults/${data.processingStartDate}`, {
              state: { iaResultData: data },
            })
          }}
        >
          <Icon name="eye" size={16} color="grey_2" />
          Ver Detalhes
        </Button>
      ),
    },
  ]

  return (
    <Box direction="column" gap={3} width="100%">
      <Box justifyContent="flex-start" width="100%">
        <Button
          variant="outlined"
          onClick={fetchIAResults}
          loading={loadingResults}
        >
          <Icon name="refresh" size={16} color="grey_1" />
          Atualizar
        </Button>
      </Box>
      {iaResults.length !== 0 ? (
        <>
          <Table
            headers={resultsTableHeaders}
            data={iaResults}
            spacing="small"
          />
        </>
      ) : (
        <Box
          height="200px"
          width="100%"
          justifyContent="center"
          alignItems="center"
          direction="column"
          gap={2}
        >
          <Icon name="file" size={48} color="grey_3" />
          <Text color="grey_3" size="small">
            Nenhum resultado de processamento encontrado
          </Text>
          <Text color="grey_3" size="small">
            Faça Upload de notas fiscais para ver os resultados aqui
          </Text>
        </Box>
      )}
    </Box>
  )
}
